import "./SystemsTesting.html";
import "./SystemsTesting.scss";

import "./FunctionalityList/FunctionalityListComponent";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import SystemsTestingComponentController from "./SystemsTestingComponentController";

export default class SystemsTestingComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            siteId: "<",
        };
        this.controller = SystemsTestingComponentController;
        this.templateUrl = "/App/Components/Site/SystemsTesting/SystemsTesting.html";
    }
}

module("mmManagePortal").component("irSystemsTesting", new SystemsTestingComponent());
